import { BasketItemModifiers, SocketPayload } from '@azzurri-group/types';
import { BasketItem, SelectedAddOn } from 'menus/interfaces';

export const createAllergensList = (existingAllergensList, newAllergensList) => {
  const allAllergensList = [...existingAllergensList, ...newAllergensList];

  return Array.from(new Set(allAllergensList));
};

const calculateTotalQuantity = (totalQuantity: number, { quantity, isComplete = true }) =>
  totalQuantity + (isComplete ? Number(quantity) : 0);

const calculateTotal = (total: number, { total: itemTotal, isComplete = true }) =>
  total + (isComplete ? Number(itemTotal) : 0);

export const calculateTotals = (itemList) => ({
  totalQuantity: itemList.reduce(calculateTotalQuantity, 0),
  total: itemList.reduce(calculateTotal, 0),
  length: itemList.length,
  updated: true,
});

export const getItemWithPrice = ({
  price = 0,
  quantity = 1,
  items,
  ...item
}: BasketItem): BasketItem => {
  const itemsWithPrice = items && items.map(getItemWithPrice);

  const unitPrice = items ? itemsWithPrice.reduce(calculateTotal, Number(price)) : price;

  return {
    ...item,
    quantity,
    price,
    unitPrice,
    total: unitPrice * quantity,
    items: itemsWithPrice || [],
  };
};

export const addKeys = (item: BasketItem, key: number) => ({ ...item, key });

const selectedAddOnsReducer = (addOn: SelectedAddOn): BasketItemModifiers.AddOn => ({
  name: addOn.name,
  id: addOn.id,
  price: addOn.price,
  unavailable: addOn.unavailable,
});

const basketItemReducer = (basketItem: BasketItem): SocketPayload.SubmitBasketItem => ({
  id: basketItem.id,
  entityId: basketItem.entityId,
  key: basketItem.key,
  itemGroupId: basketItem.itemGroupId,
  itemGroupSelectionType: basketItem.itemGroupSelectionType,
  quantity: basketItem.quantity,
  total: basketItem.total,
  price: basketItem.price,
  unitPrice: basketItem.unitPrice,
  name: basketItem.name,
  category: basketItem.category,
  isSetMenu: basketItem.isSetMenu,
  isEditable: basketItem.isEditable,
  isComplete: basketItem.isComplete,
  setMenu: basketItem.setMenu,
  categories: basketItem.categories,
  maxNumberFreeAddOns: basketItem.maxNumberFreeAddOns,
  items: basketItem.items.map(basketItemReducer),
  displayName: basketItem.displayName,
  selectedAllergens: basketItem.selectedAllergens,
  selectedAddOns: basketItem.selectedAddOns?.map(selectedAddOnsReducer),
  selectedRemovals: basketItem.selectedRemovals,
  selectedSubstitutions: basketItem.selectedSubstitutions?.map(selectedAddOnsReducer),
  selectedSize: basketItem.selectedSize,
  discountOption: basketItem.discountOption,
  originalPrice: basketItem.originalPrice,
  mealStage: basketItem.mealStage,
});

export const basketPayloadReducer = (basket): SocketPayload.SubmitBasket['basket'] => ({
  itemList: basket.itemList.map((item) => basketItemReducer(item)),
  totalQuantity: basket.totalQuantity,
  total: basket.total,
  length: basket.length,
  updated: basket.updated,
});
